// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3Vd1w","footer":"ModalCreateQualiphyProcedure_footer__2Or8_","additionData":"ModalCreateQualiphyProcedure_additionData__2JlYm"};